<template>
    <div style="background: #f2f2f2;" v-show="show">
        <common-head active="0" state="1"></common-head>

        <!-- 首页广告 -->
        <index-banner></index-banner>

        <!-- 活动内容 -->
        <div class="act">
            <div class="act-info">
                <div class="act-name">{{info.act_name}}</div>
                <div class="act-time">时间：{{info.act_start_time}} —— {{info.act_end_time}}</div>
                <div class="act-address">地址：{{info.act_address}}</div>
                <div class="act-address">费用：￥{{info.act_price}}</div>
                <div class="act-address">浏览：{{info.act_view}}人看过</div>

            </div>
            <div class="act-image">
                <img :src="info.act_image" alt="">
            </div>

            <div class="act-content" v-html="info.act_content"></div>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import indexBanner from '@/components/pc/indexBanner.vue';
    import { activity_detail } from '@/api/activity.js';

    export default {
        name: 'detail',
        components: {
            commonHead, commonFooter, indexBanner
        },
        data() {
            return {
                show: false,
                info: {
                    act_name: '资讯',
                },
            }
        },
        metaInfo() {
            site_name().then(res => {
                document.title = this.info.act_name + '-' + res.site_name;
                return {
                    title: this.info.act_name + '-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                    ],
                }
            });
        },
        created() {
            const id = this.$route.query.id;
            this.get_data(id);
        },
        methods: {
            get_data(id) {
                activity_detail({ id: id }).then(res => {
                    if (res.code == 1) {
                        this.info = res.data;
                        this.show = true;
                    }
                });
            },
        },
    }
</script>
<style scoped>
    .act {
        width: 1300px;
        margin: 50px auto 0;
        position: relative;
    }

    .act-info {
        width: 620px;
        height: 160px;
        position: absolute;
        left: 0;
        top: 55px;
        padding: 50px;
        background: #fff;
        border-top-left-radius: 20px;
    }

    .act-image {
        width: 600px;
        height: 255px;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 20px;
    }

    .act-image img {
        width: 100%;
    }

    .act-name {
        font-size: 24px;
        font-weight: 700;
        margin-bottom: 15px;
    }

    .act-time,
    .act-address {
        color: #666;
        font-size: 16px;
        margin-bottom: 5px;
    }

    .act-price {
        color: #a0ca32;
        font-size: 36px;
        font-weight: 900;
        margin-top: 30px;
    }

    .act-price span {
        font-size: 20px;
    }

    .act-price button {
        font-size: 16px;
        color: #fff;
        background: #a0ca32;
        border: none;
        height: 40px;
        border-radius: 20px;
    }

    .act-content {
        background: #fff;
        width: 1200px;
        margin: 200px auto 50px;
        padding: 50px;
        padding-top: 120px;
        z-index: 9999;
    }

    /deep/ .act-content img {
        max-width: 100%;
    }
</style>